module.exports = __webpack_public_path__ + "static/media/OpenSans-Bold.ab38fda0.ttf";